import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { hideFeedbackModal } from '../../store/actions/UserFeedbackActions';
import Alert from './TailwindComponents/Alert';
import { RootState } from '../../store';
import { Transition } from '@headlessui/react';
import { useHistory } from 'react-router-dom';

const UserFeedbackModal: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const userFeedbackModalState = useSelector((state: RootState) => state.userFeedback);
  const { showModal, modalType, message, subMsg, showContactSupport, redirectTo } = userFeedbackModalState;

  // Suppress session-related errors from rendering — these are handled silently via the session-error event
  const suppressedMessages = [
    'Missing session identifier',
    'Session invalid or expired',
    'Session validation failed',
    'Missing session',
  ];
  const isSuppressed = message && suppressedMessages.some((m) => message.toLowerCase().includes(m.toLowerCase()));

  const handleClose = () => {
    dispatch(hideFeedbackModal());
    if (redirectTo) {
      history.push(redirectTo);
    }
  };

  const handleContactSupport = () => {
    // Navigate to help/support page
    dispatch(hideFeedbackModal());
    history.push('/help/support');
  };

  const actions = [];

  if (showContactSupport) {
    actions.push({
      label: t('Contact Support'),
      onClick: handleContactSupport,
      variant: 'primary' as const,
    });
  }

  return (
    <Transition
      show={showModal && !isSuppressed}
      as={Fragment}
      appear={true}
      enter="transform ease-out duration-300 transition"
      enterFrom="opacity-0 -translate-y-10"
      enterTo="opacity-100 translate-y-0"
      leave="transform ease-in duration-200 transition"
      leaveFrom="opacity-100 translate-y-0"
      leaveTo="opacity-0 -translate-y-10"
    >
      <div className="fixed top-0 left-0 right-0 flex items-start justify-center z-[3000000000] mt-4 pointer-events-none">
        <div className="pointer-events-auto">
          <Alert
            type={modalType || 'info'}
            message={t(message || '')}
            subMessage={subMsg ? t(subMsg) : undefined}
            actions={actions.length > 0 ? actions : undefined}
            onClose={handleClose}
          />
        </div>
      </div>
    </Transition>
  );
};

export default UserFeedbackModal;
